/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_STATIC_CATEGORIES_GQL } from '@/graphql/static-queries.gql';

export default {
  namespaced: true,

  state: {
    // = data
    staticCategories: [],
  },

  mutations: {
    SET_STATIC_CATEGORIES(state, payload) {
      state.staticCategories = payload;
    },
  },

  actions: {
    getStaticCategories({ commit }) {
      apolloClient
        .query({ query: GET_STATIC_CATEGORIES_GQL })
        .then(({ data }) => {
          commit('SET_STATIC_CATEGORIES', data.staticCategories);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },

  getters: {
    // = computed properties
    staticCategories: state => state.staticCategories,
  },
};
